<template>
    <pull-to-refresh @load="reload">
        <div class="u-page-wrapper mb-36">
            <div class="u-text-center mb-16">
                <el-button type="primary" size="small" icon="el-icon-star-off" @click="$router.push({ name: 'Addresses' })">Adressen</el-button>
                <el-button type="primary" size="small" icon="el-icon-question" @click="$router.push({ name: 'Faqs' })">FAQs</el-button>
                <el-button type="primary" size="small" icon="el-icon-notebook-1" @click="openHandbook">Handbuch</el-button>
            </div>

            <div class="card-wrapper u-flex u-flex--wrap">
                <div class="mb-16 u-flex u-flex--same-height u-flex--space-around">
                    <progress-card
                        class="u-pointer"
                        :percentage="100"
                        label="Tanken"
                        @click.native="$router.push({ name: 'Tank' })"
                    />
                </div>

                <div class="mb-16 u-flex u-flex--same-height u-flex--space-around">
                    <inspection-card
                        v-if="dashboard.inspections"
                        :dates="dashboard.inspections.dates || []"
                        v-bind="dashboard.inspections.card"
                        type="dashboard"
                        forced-label="Inspektion"
                        @click.native="$router.push({ name: 'Inspections' })"
                    />
                </div>

                <div v-for="(category, i) in categories" :key="i" class="mb-16 u-flex u-flex--same-height u-flex--space-around">
                    <progress-card
                        :class="{ 'u-pointer': category.routeName }"
                        :percentage="category.percentage"
                        :label="category.label"
                        :text="category.text"
                        :icon="category.icon"
                        @click.native="category.routeName && $router.push({ name: category.routeName })"
                    />
                </div>
            </div>
        </div>
    </pull-to-refresh>
</template>

<script>
import { getInspectionsForDashboard } from '@/lib/inspections'
import ProgressCard from '@/components/ProgressCard'
import InspectionCard from '@/components/modals/InspectionCard'
import PullToRefresh from '@/components/PullToRefresh.vue'

export default {
    components: { PullToRefresh, InspectionCard, ProgressCard },

    data () {
        return {
            dashboard: {
                inspections: null,
            },
            categories: [
                // { label: 'Software', percentage: 55, text: 'Update verfügbar' },
                { label: 'Reifen', percentage: 30, text: 'Check notwendig', routeName: 'Tire' },
                { label: 'Öl', percentage: 100, icon: 'el-icon-check', routeName: 'Oil' },
            ],
        }
    },

    mounted () {
        this.loadDashboardData()
    },

    methods: {
        async reload () {
            window.location.reload()
        },

        async loadDashboardData () {
            try {
                this.dashboard.inspections = await getInspectionsForDashboard()
            } catch (e) {
                this.$notify({
                    title: 'Error',
                    message: e.message,
                    type: 'error',
                })
            }
        },

        openHandbook () {
            window.open('https://nick-hat-boecker.de/files/peugeot-handbuch.pdf', '_blank')
        },
    },
}
</script>
